import { ReservableCrossSell } from '~/components/Restaurant/ReservableCrossSellItem/ReservableCrossSellItem'
import { ReservableCrossSells } from '~/components/Restaurant/ReservableCrossSells/ReservableCrossSells'
import { gt } from '~/locale'
import Menu, { SingleMenu } from '~/shared/molecules/Menu/MenuView'

import { ReserveButton, Wrapper } from './ReservableMenuWithCrossSellsShards'

type ReservableMenuWithCrossSellsProps = {
  menus: SingleMenu[]
  crossSells: ReservableCrossSell[]
  onReserveClick: () => void
}

export const ReservableMenuWithCrossSells = ({ menus, crossSells, onReserveClick }: ReservableMenuWithCrossSellsProps) => {
  return (
    <Wrapper>
      {menus?.map(menu => <Menu key={menu.id} menu={menu} index={menu.position} />)}
      <ReservableCrossSells crossSells={crossSells} />
      <ReserveButton onClick={onReserveClick} color='orange' label={gt.tp('RestaurantPage', 'Book a table')} />
    </Wrapper>
  )
}
